export { StarIndicator } from './StarIndicator'